import http from "../http";
import Service from "../../Service";

/**
 * Simula a resposta de uma API assíncrona (mesmo formato `{ data }` do
 * axios), com um pequeno atraso para que a UI exiba o loading real.
 * Quando os endpoints reais existirem, cada método abaixo pode ser
 * substituído por uma chamada `http.get(...)` mantendo a mesma assinatura.
 */
function mockResolve(data, delay = 600) {
    return new Promise((resolve) => {
        setTimeout(() => resolve({ data }), delay);
    });
}

export default class DashboardV2Service extends Service {
    // Barra de filtros do topo do painel
    getFiltros() {
        return mockResolve(
            {
                periodOptions: [
                    { value: "mes", label: "Período: agosto/2026" },
                    { value: "tri", label: "Período: 3º trimestre" },
                    { value: "ano", label: "Período: 2026" },
                ],
                companyOptions: [
                    { value: "todas", label: "Empresas: todas" },
                    { value: "matriz", label: "Matriz" },
                    { value: "rede", label: "Rede Nordeste" },
                ],
                branchOptions: [
                    { value: "todas", label: "Filial: todas" },
                    { value: "rec", label: "Recife" },
                    { value: "nat", label: "Natal" },
                ],
                buyerOptions: [
                    { value: "todos", label: "Comprador: todos" },
                    { value: "ana", label: "Ana Beatriz" },
                    { value: "carlos", label: "Carlos Menezes" },
                ],
                categoryOptions: [
                    { value: "todas", label: "Categoria: todas" },
                    { value: "mercearia", label: "Mercearia seca" },
                    { value: "bebidas", label: "Bebidas" },
                    { value: "hortifruti", label: "Hortifrúti" },
                ],
                defaults: {
                    period: "mes",
                    company: "todas",
                    branch: "rec",
                    buyer: "todos",
                    category: "mercearia",
                },
            },
            300
        );
    }

    // Seção 1 — Cotações
    getCotacoes(filters) {
        // TODO: confirmar o formato de resposta da API real e ajustar o
        // mapeamento para `{ kpis, historic }` esperado pelo front, se for diferente.
        return http.get("clients/dashboard/requests", {
            headers: this.getHeaders(),
            params: filters,
        });

        // Mock antigo, mantido comentado como referência do formato de dado
        // esperado pelo front (`{ kpis, historic }`) até a API real ser validada:
        //
        //         return mockResolve(
        //             {
        //                 kpis: [
        //                     {
        //                         key: "total",
        //                         value: 239,
        //                         deltaMonthValue: 18,
        //                         deltaMonthPct: 8.1,
        //                         deltaYearValue: 42,
        //                         deltaYearPct: 21.3,
        //                     },
        //                     {
        //                         key: "inProgress",
        //                         value: 85,
        //                         deltaMonthValue: 4,
        //                         deltaMonthPct: 4.9,
        //                         deltaYearValue: 19,
        //                         deltaYearPct: 28.8,
        //                     },
        //                     {
        //                         key: "closed",
        //                         value: 145,
        //                         deltaMonthValue: 15,
        //                         deltaMonthPct: 11.5,
        //                         deltaYearValue: 28,
        //                         deltaYearPct: 23.9,
        //                     },
        //                     {
        //                         key: "frozen",
        //                         value: 9,
        //                         deltaMonthValue: -1,
        //                         deltaMonthPct: -10.0,
        //                         deltaYearValue: -5,
        //                         deltaYearPct: -35.7,
        //                     },
        //                     {
        //                         key: "avgCompetitors",
        //                         value: 23.13,
        //                         deltaMonthValue: 1.4,
        //                         deltaMonthPct: 6.4,
        //                         deltaYearValue: 4.8,
        //                         deltaYearPct: 26.2,
        //                     },
        //                     {
        //                         key: "avgProducts",
        //                         value: 55.04,
        //                         deltaMonthValue: 0.2,
        //                         deltaMonthPct: 0.4,
        //                         deltaYearValue: -1.9,
        //                         deltaYearPct: -3.3,
        //                     },
        //                     {
        //                         key: "avgOffers",
        //                         value: 46.08,
        //                         deltaMonthValue: -3.2,
        //                         deltaMonthPct: -6.5,
        //                         deltaYearValue: 2.6,
        //                         deltaYearPct: 6.0,
        //                     },
        //                     {
        //                         key: "sellerEngagement",
        //                         value: 61.66,
        //                         progress: 61.66,
        //                         deltaMonthValue: -8.34,
        //                         deltaYearValue: 4.1,
        //                     },
        //                     {
        //                         key: "offerCoverage",
        //                         value: 87.9,
        //                         progress: 87.9,
        //                         deltaMonthValue: -2.1,
        //                         deltaYearValue: 1.8,
        //                     },
        //                     {
        //                         key: "orderCoverage",
        //                         value: 77.79,
        //                         progress: 77.79,
        //                         deltaMonthValue: -2.21,
        //                         deltaYearValue: 5.6,
        //                     },
        //                 ],
        //                 historic: [
        //                     {
        //                         month: "2025-08",
        //                         closed: 96,
        //                         inProgress: 58,
        //                         frozen: 14,
        //                         avgCompetitors: 17.8,
        //                         avgProducts: 56.9,
        //                         avgOffers: 43.5,
        //                         sellerEngagement: 57.6,
        //                         offerCoverage: 86.1,
        //                         orderCoverage: 72.2,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         closed: 104,
        //                         inProgress: 61,
        //                         frozen: 14,
        //                         avgCompetitors: 18.3,
        //                         avgProducts: 56.6,
        //                         avgOffers: 44.1,
        //                         sellerEngagement: 58.4,
        //                         offerCoverage: 86.6,
        //                         orderCoverage: 73.1,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         closed: 112,
        //                         inProgress: 65,
        //                         frozen: 13,
        //                         avgCompetitors: 19.1,
        //                         avgProducts: 56.2,
        //                         avgOffers: 44.8,
        //                         sellerEngagement: 60.1,
        //                         offerCoverage: 87.2,
        //                         orderCoverage: 74.0,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         closed: 118,
        //                         inProgress: 68,
        //                         frozen: 13,
        //                         avgCompetitors: 19.8,
        //                         avgProducts: 55.8,
        //                         avgOffers: 45.4,
        //                         sellerEngagement: 62.3,
        //                         offerCoverage: 87.9,
        //                         orderCoverage: 75.2,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         closed: 131,
        //                         inProgress: 74,
        //                         frozen: 12,
        //                         avgCompetitors: 20.4,
        //                         avgProducts: 55.4,
        //                         avgOffers: 46.0,
        //                         sellerEngagement: 64.8,
        //                         offerCoverage: 88.4,
        //                         orderCoverage: 76.4,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         closed: 108,
        //                         inProgress: 63,
        //                         frozen: 12,
        //                         avgCompetitors: 20.9,
        //                         avgProducts: 55.1,
        //                         avgOffers: 46.6,
        //                         sellerEngagement: 66.2,
        //                         offerCoverage: 88.9,
        //                         orderCoverage: 77.3,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         closed: 116,
        //                         inProgress: 68,
        //                         frozen: 11,
        //                         avgCompetitors: 21.2,
        //                         avgProducts: 54.9,
        //                         avgOffers: 47.2,
        //                         sellerEngagement: 67.4,
        //                         offerCoverage: 89.2,
        //                         orderCoverage: 78.1,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         closed: 124,
        //                         inProgress: 72,
        //                         frozen: 11,
        //                         avgCompetitors: 21.4,
        //                         avgProducts: 54.8,
        //                         avgOffers: 47.8,
        //                         sellerEngagement: 68.1,
        //                         offerCoverage: 89.5,
        //                         orderCoverage: 78.6,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         closed: 131,
        //                         inProgress: 76,
        //                         frozen: 10,
        //                         avgCompetitors: 21.7,
        //                         avgProducts: 54.7,
        //                         avgOffers: 48.3,
        //                         sellerEngagement: 69.0,
        //                         offerCoverage: 89.7,
        //                         orderCoverage: 79.1,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         closed: 136,
        //                         inProgress: 79,
        //                         frozen: 10,
        //                         avgCompetitors: 22.1,
        //                         avgProducts: 54.8,
        //                         avgOffers: 48.8,
        //                         sellerEngagement: 69.6,
        //                         offerCoverage: 89.9,
        //                         orderCoverage: 79.5,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         closed: 140,
        //                         inProgress: 82,
        //                         frozen: 10,
        //                         avgCompetitors: 22.4,
        //                         avgProducts: 54.9,
        //                         avgOffers: 49.1,
        //                         sellerEngagement: 70.2,
        //                         offerCoverage: 90.1,
        //                         orderCoverage: 79.8,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         closed: 142,
        //                         inProgress: 81,
        //                         frozen: 10,
        //                         avgCompetitors: 21.7,
        //                         avgProducts: 54.8,
        //                         avgOffers: 49.3,
        //                         sellerEngagement: 70.0,
        //                         offerCoverage: 90.0,
        //                         orderCoverage: 80.0,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         closed: 145,
        //                         inProgress: 85,
        //                         frozen: 9,
        //                         avgCompetitors: 23.1,
        //                         avgProducts: 55.0,
        //                         avgOffers: 46.1,
        //                         sellerEngagement: 61.7,
        //                         offerCoverage: 87.9,
        //                         orderCoverage: 77.8,
        //                     },
        //                 ],
        //             },
        //             550
        //         );
    }

    // Seção 2 — Pedidos/Compras
    getPedidos(filters) {
        // TODO: confirmar o formato de resposta da API real e ajustar o
        // mapeamento para `{ kpis, historic, ranking }` esperado pelo front, se for diferente.
        return http.get("clients/dashboard/orders", {
            headers: this.getHeaders(),
            params: filters,
        });

        // Mock antigo, mantido comentado como referência do formato de dado
        // esperado pelo front (`{ kpis, historic, ranking }`) até a API real ser validada:
        //
        //         // eslint-disable-line no-unused-vars
        //         return mockResolve(
        //             {
        //                 kpis: [
        //                     {
        //                         key: "ordersGenerated",
        //                         value: 312,
        //                         perClosedQuote: 2.2,
        //                         deltaMonthValue: 29,
        //                         deltaMonthPct: 10.2,
        //                         deltaYearValue: 76,
        //                         deltaYearPct: 32.2,
        //                     },
        //                     {
        //                         key: "ordersValue",
        //                         value: 4120000,
        //                         deltaMonthValue: 540000,
        //                         deltaMonthPct: 15.1,
        //                         deltaYearValue: 1180000,
        //                         deltaYearPct: 40.2,
        //                     },
        //                     {
        //                         key: "avgTicket",
        //                         value: 13189,
        //                         itemsPerOrder: 10.6,
        //                         itemsPerOrderDeltaMonth: 0.3,
        //                         deltaMonthValue: 594,
        //                         deltaMonthPct: 4.7,
        //                         deltaYearValue: 727,
        //                         deltaYearPct: 5.8,
        //                     },
        //                     {
        //                         key: "savingsGenerated",
        //                         value: 705000,
        //                         pctOfLastCost: 14.6,
        //                         deltaMonthValue: 94000,
        //                         deltaMonthPct: 15.4,
        //                         deltaYearValue: 270000,
        //                         deltaYearPct: 62.1,
        //                     },
        //                 ],
        //                 historic: [
        //                     {
        //                         month: "2025-08",
        //                         quoted: 412000,
        //                         approved: 366000,
        //                         ordersIssued: 148,
        //                         savingsPct: 11.2,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         quoted: 438000,
        //                         approved: 389000,
        //                         ordersIssued: 162,
        //                         savingsPct: 11.2,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         quoted: 472000,
        //                         approved: 417000,
        //                         ordersIssued: 174,
        //                         savingsPct: 11.6,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         quoted: 516000,
        //                         approved: 452000,
        //                         ordersIssued: 189,
        //                         savingsPct: 12.4,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         quoted: 604000,
        //                         approved: 527000,
        //                         ordersIssued: 214,
        //                         savingsPct: 12.7,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         quoted: 495000,
        //                         approved: 431000,
        //                         ordersIssued: 178,
        //                         savingsPct: 12.9,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         quoted: 528000,
        //                         approved: 456000,
        //                         ordersIssued: 192,
        //                         savingsPct: 13.6,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         quoted: 612000,
        //                         approved: 528000,
        //                         ordersIssued: 214,
        //                         savingsPct: 13.7,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         quoted: 705000,
        //                         approved: 601000,
        //                         ordersIssued: 236,
        //                         savingsPct: 14.7,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         quoted: 768000,
        //                         approved: 655000,
        //                         ordersIssued: 258,
        //                         savingsPct: 14.7,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         quoted: 812000,
        //                         approved: 692000,
        //                         ordersIssued: 274,
        //                         savingsPct: 14.8,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         quoted: 895000,
        //                         approved: 762000,
        //                         ordersIssued: 283,
        //                         savingsPct: 14.9,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         quoted: 1028000,
        //                         approved: 877000,
        //                         ordersIssued: 312,
        //                         savingsPct: 14.6,
        //                     },
        //                 ],
        //                 ranking: [
        //                     {
        //                         id: "PC-2026-1288",
        //                         quoteId: "#1288",
        //                         supplier: "Distribuidora Nordeste",
        //                         buyer: "Ana Beatriz Souza",
        //                         items: 14,
        //                         value: 86400,
        //                         savings: 13800,
        //                         pct: 13.8,
        //                         issuedAt: "27/08 · 09:42",
        //                         status: "Emitido",
        //                     },
        //                     {
        //                         id: "PC-2026-1287",
        //                         quoteId: "#1284",
        //                         supplier: "Atacadão São José",
        //                         buyer: "Carlos Menezes",
        //                         items: 9,
        //                         value: 52180,
        //                         savings: 7100,
        //                         pct: 12.0,
        //                         issuedAt: "27/08 · 08:15",
        //                         status: "Emitido",
        //                     },
        //                     {
        //                         id: "PC-2026-1286",
        //                         quoteId: "#1279",
        //                         supplier: "Comercial Potiguar",
        //                         buyer: "Fernanda Lima",
        //                         items: 22,
        //                         value: 128900,
        //                         savings: 21400,
        //                         pct: 14.2,
        //                         issuedAt: "26/08 · 17:30",
        //                         status: "Aprovado",
        //                     },
        //                     {
        //                         id: "PC-2026-1285",
        //                         quoteId: "#1276",
        //                         supplier: "Alimentos Recife",
        //                         buyer: "João Petrucci",
        //                         items: 6,
        //                         value: 31250,
        //                         savings: 3400,
        //                         pct: 9.8,
        //                         issuedAt: "26/08 · 15:04",
        //                         status: "Aprovado",
        //                     },
        //                     {
        //                         id: "PC-2026-1284",
        //                         quoteId: "#1271",
        //                         supplier: "Grão Fino Alimentos",
        //                         buyer: "Ana Beatriz Souza",
        //                         items: 18,
        //                         value: 97600,
        //                         savings: 16900,
        //                         pct: 14.8,
        //                         issuedAt: "26/08 · 11:22",
        //                         status: "Em aprovação",
        //                     },
        //                     {
        //                         id: "PC-2026-1283",
        //                         quoteId: "#1268",
        //                         supplier: "Distribuidora Nordeste",
        //                         buyer: "Marcos Vinícius",
        //                         items: 11,
        //                         value: 64300,
        //                         savings: 8800,
        //                         pct: 12.0,
        //                         issuedAt: "25/08 · 16:48",
        //                         status: "Emitido",
        //                     },
        //                 ],
        //             },
        //             650
        //         );
    }

    // Seção 3 — Análise de Mix/Itens
    getItens(filters) {
        // TODO: confirmar o formato de resposta da API real e ajustar o
        // mapeamento para `{ kpis, historic, ranking }` esperado pelo front, se for diferente.
        return http.get("clients/dashboard/products", {
            headers: this.getHeaders(),
            params: filters,
        });

        // Mock antigo, mantido comentado como referência do formato de dado
        // esperado pelo front (`{ kpis, historic, ranking }`) até a API real ser validada:
        //
        //         // eslint-disable-line no-unused-vars
        //         return mockResolve(
        //             {
        //                 kpis: [
        //                     {
        //                         key: "inRegistry",
        //                         value: 41280,
        //                         deltaMonthValue: 370,
        //                         deltaMonthPct: 0.9,
        //                         deltaYearValue: 2640,
        //                         deltaYearPct: 6.8,
        //                     },
        //                     {
        //                         key: "quoted",
        //                         value: 5184,
        //                         progress: 12.6,
        //                         monthDeltaPct: 0.4,
        //                         deltaMonthValue: 212,
        //                         deltaMonthPct: 4.3,
        //                         deltaYearValue: 916,
        //                         deltaYearPct: 21.5,
        //                     },
        //                     {
        //                         key: "proposed",
        //                         value: 4448,
        //                         progress: 85.8,
        //                         monthDeltaPct: 0.1,
        //                         deltaMonthValue: 186,
        //                         deltaMonthPct: 4.4,
        //                         deltaYearValue: 934,
        //                         deltaYearPct: 26.6,
        //                     },
        //                     {
        //                         key: "purchased",
        //                         value: 3318,
        //                         progress: 64,
        //                         monthDeltaPct: 0.5,
        //                         deltaMonthValue: 160,
        //                         deltaMonthPct: 5.1,
        //                         deltaYearValue: 708,
        //                         deltaYearPct: 27.1,
        //                     },
        //                 ],
        //                 historic: [
        //                     {
        //                         month: "2025-08",
        //                         quotedItems: 2860,
        //                         proposedItems: 2290,
        //                         purchasedItems: 1580,
        //                         registryCoverage: 7.3,
        //                         quotedToProposedRate: 80.1,
        //                         quotedToPurchasedRate: 55.2,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         quotedItems: 2980,
        //                         proposedItems: 2410,
        //                         purchasedItems: 1690,
        //                         registryCoverage: 7.6,
        //                         quotedToProposedRate: 80.9,
        //                         quotedToPurchasedRate: 56.7,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         quotedItems: 3140,
        //                         proposedItems: 2560,
        //                         purchasedItems: 1810,
        //                         registryCoverage: 8.0,
        //                         quotedToProposedRate: 81.5,
        //                         quotedToPurchasedRate: 57.6,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         quotedItems: 3320,
        //                         proposedItems: 2730,
        //                         purchasedItems: 1950,
        //                         registryCoverage: 8.4,
        //                         quotedToProposedRate: 82.2,
        //                         quotedToPurchasedRate: 58.7,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         quotedItems: 3610,
        //                         proposedItems: 3010,
        //                         purchasedItems: 2180,
        //                         registryCoverage: 9.1,
        //                         quotedToProposedRate: 83.4,
        //                         quotedToPurchasedRate: 60.4,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         quotedItems: 3450,
        //                         proposedItems: 2880,
        //                         purchasedItems: 2070,
        //                         registryCoverage: 8.7,
        //                         quotedToProposedRate: 83.5,
        //                         quotedToPurchasedRate: 60.0,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         quotedItems: 3680,
        //                         proposedItems: 3070,
        //                         purchasedItems: 2230,
        //                         registryCoverage: 9.2,
        //                         quotedToProposedRate: 83.4,
        //                         quotedToPurchasedRate: 60.6,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         quotedItems: 3880,
        //                         proposedItems: 3224,
        //                         purchasedItems: 2350,
        //                         registryCoverage: 9.7,
        //                         quotedToProposedRate: 83.1,
        //                         quotedToPurchasedRate: 60.6,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         quotedItems: 4188,
        //                         proposedItems: 3526,
        //                         purchasedItems: 2588,
        //                         registryCoverage: 10.4,
        //                         quotedToProposedRate: 84.2,
        //                         quotedToPurchasedRate: 61.8,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         quotedItems: 4486,
        //                         proposedItems: 3808,
        //                         purchasedItems: 2808,
        //                         registryCoverage: 11.1,
        //                         quotedToProposedRate: 84.9,
        //                         quotedToPurchasedRate: 62.6,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         quotedItems: 4746,
        //                         proposedItems: 4053,
        //                         purchasedItems: 3005,
        //                         registryCoverage: 11.6,
        //                         quotedToProposedRate: 85.4,
        //                         quotedToPurchasedRate: 63.3,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         quotedItems: 4972,
        //                         proposedItems: 4262,
        //                         purchasedItems: 3158,
        //                         registryCoverage: 12.2,
        //                         quotedToProposedRate: 85.7,
        //                         quotedToPurchasedRate: 63.5,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         quotedItems: 5184,
        //                         proposedItems: 4448,
        //                         purchasedItems: 3318,
        //                         registryCoverage: 12.6,
        //                         quotedToProposedRate: 85.8,
        //                         quotedToPurchasedRate: 64.0,
        //                     },
        //                 ],
        //                 ranking: [
        //                     {
        //                         product: "Arroz tipo 1 · 5 kg",
        //                         quotes: 96,
        //                         quotedItems: 2304,
        //                         purchasedItems: 1612,
        //                         approved: 412000,
        //                         monthChangePct: 11.8,
        //                         yearChangePct: 34.6,
        //                     },
        //                     {
        //                         product: "Óleo de soja · 900 ml",
        //                         quotes: 88,
        //                         quotedItems: 1936,
        //                         purchasedItems: 1289,
        //                         approved: 349000,
        //                         monthChangePct: 6.4,
        //                         yearChangePct: 28.1,
        //                     },
        //                     {
        //                         product: "Feijão carioca · 1 kg",
        //                         quotes: 81,
        //                         quotedItems: 1782,
        //                         purchasedItems: 1104,
        //                         approved: 318000,
        //                         monthChangePct: -3.1,
        //                         yearChangePct: 19.7,
        //                     },
        //                     {
        //                         product: "Açúcar refinado · 1 kg",
        //                         quotes: 74,
        //                         quotedItems: 1554,
        //                         purchasedItems: 942,
        //                         approved: 262000,
        //                         monthChangePct: 4.9,
        //                         yearChangePct: 12.4,
        //                     },
        //                     {
        //                         product: "Café torrado · 500 g",
        //                         quotes: 69,
        //                         quotedItems: 1449,
        //                         purchasedItems: 1018,
        //                         approved: 291000,
        //                         monthChangePct: 9.2,
        //                         yearChangePct: 41.3,
        //                     },
        //                     {
        //                         product: "Leite UHT · 1 L",
        //                         quotes: 62,
        //                         quotedItems: 1240,
        //                         purchasedItems: 706,
        //                         approved: 232000,
        //                         monthChangePct: -5.4,
        //                         yearChangePct: 7.8,
        //                     },
        //                 ],
        //             },
        //             600
        //         );
    }

    // Seção 4 — Análise de Fornecedores
    getFornecedores(filters) {
        // TODO: confirmar o formato de resposta da API real e ajustar o
        // mapeamento para `{ kpis, historic, ranking }` esperado pelo front, se for diferente.
        return http.get("clients/dashboard/providers", {
            headers: this.getHeaders(),
            params: filters,
        });

        // Mock antigo, mantido comentado como referência do formato de dado
        // esperado pelo front (`{ kpis, historic, ranking }`) até a API real ser validada:
        //
        //         // eslint-disable-line no-unused-vars
        //         return mockResolve(
        //             {
        //                 kpis: [
        //                     {
        //                         key: "inRegistry",
        //                         value: 214,
        //                         deltaMonthValue: 5,
        //                         deltaMonthPct: 2.4,
        //                         deltaYearValue: 28,
        //                         deltaYearPct: 15.1,
        //                     },
        //                     {
        //                         key: "acquired",
        //                         value: 5,
        //                         pctOfRegistry: 2.3,
        //                         alreadyEngaged: 3,
        //                         deltaMonthValue: 1,
        //                         deltaMonthPct: 25.0,
        //                         deltaYearValue: 3,
        //                         deltaYearPct: 150.0,
        //                     },
        //                     {
        //                         key: "engaged",
        //                         value: 87,
        //                         progress: 40.7,
        //                         monthDeltaPct: 3.3,
        //                         deltaMonthValue: 8,
        //                         deltaMonthPct: 10.1,
        //                         deltaYearValue: 30,
        //                         deltaYearPct: 52.6,
        //                     },
        //                     {
        //                         key: "withOrder",
        //                         value: 38,
        //                         progress: 43.7,
        //                         pctOfRegistry: 17.8,
        //                         deltaMonthValue: 4,
        //                         deltaMonthPct: 11.8,
        //                         deltaYearValue: 12,
        //                         deltaYearPct: 46.2,
        //                     },
        //                 ],
        //                 historic: [
        //                     {
        //                         month: "2025-08",
        //                         withOrder: 13,
        //                         withoutOrder: 20,
        //                         avgPerQuote: 2.3,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         withOrder: 14,
        //                         withoutOrder: 21,
        //                         avgPerQuote: 2.4,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         withOrder: 16,
        //                         withoutOrder: 23,
        //                         avgPerQuote: 2.5,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         withOrder: 18,
        //                         withoutOrder: 25,
        //                         avgPerQuote: 2.6,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         withOrder: 21,
        //                         withoutOrder: 28,
        //                         avgPerQuote: 2.8,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         withOrder: 19,
        //                         withoutOrder: 26,
        //                         avgPerQuote: 2.7,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         withOrder: 20,
        //                         withoutOrder: 28,
        //                         avgPerQuote: 2.8,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         withOrder: 22,
        //                         withoutOrder: 30,
        //                         avgPerQuote: 2.9,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         withOrder: 25,
        //                         withoutOrder: 33,
        //                         avgPerQuote: 3.1,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         withOrder: 28,
        //                         withoutOrder: 36,
        //                         avgPerQuote: 3.3,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         withOrder: 31,
        //                         withoutOrder: 40,
        //                         avgPerQuote: 3.5,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         withOrder: 34,
        //                         withoutOrder: 45,
        //                         avgPerQuote: 3.6,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         withOrder: 38,
        //                         withoutOrder: 49,
        //                         avgPerQuote: 3.8,
        //                     },
        //                 ],
        //                 ranking: [
        //                     {
        //                         name: "Distribuidora Nordeste",
        //                         wins: 31,
        //                         approved: 968000,
        //                         winRate: 41.9,
        //                         monthChangePct: 9.6,
        //                         yearChangePct: 37.4,
        //                     },
        //                     {
        //                         name: "Atacadão São José",
        //                         wins: 26,
        //                         approved: 812000,
        //                         winRate: 38.2,
        //                         monthChangePct: 5.2,
        //                         yearChangePct: 24.8,
        //                     },
        //                     {
        //                         name: "Comercial Potiguar",
        //                         wins: 22,
        //                         approved: 704000,
        //                         winRate: 36.1,
        //                         monthChangePct: -1.8,
        //                         yearChangePct: 16.5,
        //                     },
        //                     {
        //                         name: "Alimentos Recife",
        //                         wins: 17,
        //                         approved: 561000,
        //                         winRate: 31.5,
        //                         monthChangePct: 3.4,
        //                         yearChangePct: 11.2,
        //                     },
        //                     {
        //                         name: "Grão Fino Alimentos",
        //                         wins: 13,
        //                         approved: 438000,
        //                         winRate: 27.7,
        //                         monthChangePct: -7.9,
        //                         yearChangePct: -4.6,
        //                     },
        //                 ],
        //             },
        //             700
        //         );
    }

    // Seção 5 — Análise dos compradores
    getCompradores(filters) {
        // TODO: confirmar o formato de resposta da API real e ajustar o
        // mapeamento para `{ kpis, historic, ranking }` esperado pelo front, se for diferente.
        return http.get("clients/dashboard/buyers", {
            headers: this.getHeaders(),
            params: filters,
        });

        // Mock antigo, mantido comentado como referência do formato de dado
        // esperado pelo front (`{ kpis, historic, ranking }`) até a API real ser validada:
        //
        //         // eslint-disable-line no-unused-vars
        //         return mockResolve(
        //             {
        //                 kpis: [
        //                     {
        //                         key: "activeInPeriod",
        //                         value: 9,
        //                         totalRegistered: 12,
        //                         deltaMonthValue: 1,
        //                         deltaMonthPct: 12.5,
        //                         deltaYearValue: 3,
        //                         deltaYearPct: 50.0,
        //                     },
        //                     {
        //                         key: "quotesPerBuyer",
        //                         value: 26.6,
        //                         totalQuotes: 239,
        //                         totalBuyers: 9,
        //                         deltaMonthValue: 1.4,
        //                         deltaMonthPct: 5.6,
        //                         deltaYearValue: 4.2,
        //                         deltaYearPct: 18.7,
        //                     },
        //                     {
        //                         key: "savingsPerBuyer",
        //                         value: 78000,
        //                         totalSavings: 705000,
        //                         deltaMonthValue: 6000,
        //                         deltaMonthPct: 8.3,
        //                         deltaYearValue: 24000,
        //                         deltaYearPct: 44.4,
        //                     },
        //                     {
        //                         key: "avgClosingDays",
        //                         value: 5.2,
        //                         targetDays: 6,
        //                         deltaMonthValue: -0.3,
        //                         deltaMonthPct: -5.5,
        //                         deltaYearValue: -1.1,
        //                         deltaYearPct: -17.5,
        //                     },
        //                 ],
        //                 // Tabela longa: uma linha por combinação de mês + comprador, como o
        //                 // resultado de um `GROUP BY month, buyer` — sem cor/tipo/dashStyle,
        //                 // que continuam sendo decisão do componente que monta o gráfico. O
        //                 // rol de compradores é dado (pode variar), por isso vem como valor de
        //                 // uma coluna em vez de uma propriedade fixa por linha de mês.
        //                 historic: [
        //                     {
        //                         month: "2025-08",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 286000,
        //                     },
        //                     {
        //                         month: "2025-08",
        //                         buyer: "Carlos Menezes",
        //                         value: 244000,
        //                     },
        //                     { month: "2025-08", buyer: "Fernanda Lima", value: 212000 },
        //                     {
        //                         month: "2025-08",
        //                         buyer: "Outros compradores",
        //                         value: 162000,
        //                     },
        //                     {
        //                         month: "2025-08",
        //                         buyer: "Cotações por comprador",
        //                         value: 18.4,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 304000,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         buyer: "Carlos Menezes",
        //                         value: 258000,
        //                     },
        //                     { month: "2025-09", buyer: "Fernanda Lima", value: 224000 },
        //                     {
        //                         month: "2025-09",
        //                         buyer: "Outros compradores",
        //                         value: 172000,
        //                     },
        //                     {
        //                         month: "2025-09",
        //                         buyer: "Cotações por comprador",
        //                         value: 19.2,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 322000,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         buyer: "Carlos Menezes",
        //                         value: 276000,
        //                     },
        //                     { month: "2025-10", buyer: "Fernanda Lima", value: 238000 },
        //                     {
        //                         month: "2025-10",
        //                         buyer: "Outros compradores",
        //                         value: 184000,
        //                     },
        //                     {
        //                         month: "2025-10",
        //                         buyer: "Cotações por comprador",
        //                         value: 20.1,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 371000,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         buyer: "Carlos Menezes",
        //                         value: 318000,
        //                     },
        //                     { month: "2025-11", buyer: "Fernanda Lima", value: 274000 },
        //                     {
        //                         month: "2025-11",
        //                         buyer: "Outros compradores",
        //                         value: 212000,
        //                     },
        //                     {
        //                         month: "2025-11",
        //                         buyer: "Cotações por comprador",
        //                         value: 21.6,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 318000,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         buyer: "Carlos Menezes",
        //                         value: 272000,
        //                     },
        //                     { month: "2025-12", buyer: "Fernanda Lima", value: 236000 },
        //                     {
        //                         month: "2025-12",
        //                         buyer: "Outros compradores",
        //                         value: 182000,
        //                     },
        //                     {
        //                         month: "2025-12",
        //                         buyer: "Cotações por comprador",
        //                         value: 19.8,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 336000,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         buyer: "Carlos Menezes",
        //                         value: 288000,
        //                     },
        //                     { month: "2026-01", buyer: "Fernanda Lima", value: 250000 },
        //                     {
        //                         month: "2026-01",
        //                         buyer: "Outros compradores",
        //                         value: 192000,
        //                     },
        //                     {
        //                         month: "2026-01",
        //                         buyer: "Cotações por comprador",
        //                         value: 20.6,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 372000,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         buyer: "Carlos Menezes",
        //                         value: 318000,
        //                     },
        //                     { month: "2026-02", buyer: "Fernanda Lima", value: 276000 },
        //                     {
        //                         month: "2026-02",
        //                         buyer: "Outros compradores",
        //                         value: 212000,
        //                     },
        //                     {
        //                         month: "2026-02",
        //                         buyer: "Cotações por comprador",
        //                         value: 21.8,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 424000,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         buyer: "Carlos Menezes",
        //                         value: 362000,
        //                     },
        //                     { month: "2026-03", buyer: "Fernanda Lima", value: 314000 },
        //                     {
        //                         month: "2026-03",
        //                         buyer: "Outros compradores",
        //                         value: 242000,
        //                     },
        //                     {
        //                         month: "2026-03",
        //                         buyer: "Cotações por comprador",
        //                         value: 22.9,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 462000,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         buyer: "Carlos Menezes",
        //                         value: 396000,
        //                     },
        //                     { month: "2026-04", buyer: "Fernanda Lima", value: 342000 },
        //                     {
        //                         month: "2026-04",
        //                         buyer: "Outros compradores",
        //                         value: 264000,
        //                     },
        //                     {
        //                         month: "2026-04",
        //                         buyer: "Cotações por comprador",
        //                         value: 23.8,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 496000,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         buyer: "Carlos Menezes",
        //                         value: 424000,
        //                     },
        //                     { month: "2026-05", buyer: "Fernanda Lima", value: 368000 },
        //                     {
        //                         month: "2026-05",
        //                         buyer: "Outros compradores",
        //                         value: 282000,
        //                     },
        //                     {
        //                         month: "2026-05",
        //                         buyer: "Cotações por comprador",
        //                         value: 24.6,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 528000,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         buyer: "Carlos Menezes",
        //                         value: 452000,
        //                     },
        //                     { month: "2026-06", buyer: "Fernanda Lima", value: 392000 },
        //                     {
        //                         month: "2026-06",
        //                         buyer: "Outros compradores",
        //                         value: 300000,
        //                     },
        //                     {
        //                         month: "2026-06",
        //                         buyer: "Cotações por comprador",
        //                         value: 25.3,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 552000,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         buyer: "Carlos Menezes",
        //                         value: 472000,
        //                     },
        //                     { month: "2026-07", buyer: "Fernanda Lima", value: 408000 },
        //                     {
        //                         month: "2026-07",
        //                         buyer: "Outros compradores",
        //                         value: 314000,
        //                     },
        //                     {
        //                         month: "2026-07",
        //                         buyer: "Cotações por comprador",
        //                         value: 25.2,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         buyer: "Ana Beatriz Souza",
        //                         value: 604000,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         buyer: "Carlos Menezes",
        //                         value: 518000,
        //                     },
        //                     { month: "2026-08", buyer: "Fernanda Lima", value: 448000 },
        //                     {
        //                         month: "2026-08",
        //                         buyer: "Outros compradores",
        //                         value: 344000,
        //                     },
        //                     {
        //                         month: "2026-08",
        //                         buyer: "Cotações por comprador",
        //                         value: 26.6,
        //                     },
        //                 ],
        //                 ranking: [
        //                     {
        //                         name: "Ana Beatriz Souza",
        //                         quotes: 48,
        //                         approved: 1042000,
        //                         savings: 168000,
        //                         pct: 15.8,
        //                         monthChangePct: 12.4,
        //                         yearChangePct: 41.2,
        //                     },
        //                     {
        //                         name: "Carlos Menezes",
        //                         quotes: 41,
        //                         approved: 894000,
        //                         savings: 141000,
        //                         pct: 14.9,
        //                         monthChangePct: 8.1,
        //                         yearChangePct: 33.7,
        //                     },
        //                     {
        //                         name: "Fernanda Lima",
        //                         quotes: 37,
        //                         approved: 812000,
        //                         savings: 118000,
        //                         pct: 13.7,
        //                         monthChangePct: -2.6,
        //                         yearChangePct: 18.4,
        //                     },
        //                     {
        //                         name: "João Petrucci",
        //                         quotes: 31,
        //                         approved: 655000,
        //                         savings: 92000,
        //                         pct: 12.6,
        //                         monthChangePct: 5.3,
        //                         yearChangePct: 27.9,
        //                     },
        //                     {
        //                         name: "Marcos Vinícius",
        //                         quotes: 24,
        //                         approved: 498000,
        //                         savings: 61000,
        //                         pct: 11.4,
        //                         monthChangePct: -6.8,
        //                         yearChangePct: 9.5,
        //                     },
        //                 ],
        //             },
        //             600
        //         );
    }
}
